import './RoleCardsList.scss';
import { MyRolesQuery } from 'generated/graphql';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import RoleCard from '../../RoleCard/RoleCard';

interface IRoleCardsList {
  roles: MyRolesQuery['myRoles'];
}

const RoleCardsList: FC<IRoleCardsList> = ({ roles }) => {
  const { t } = useTranslation();
  return (
    <div className="RoleCardsList" aria-label={t('roles.listOfYourRoles')}>
      {roles?.map(role => (
        <RoleCard
          key={role.id}
          roleId={role.id}
          roleName={role.name}
          companyName={role.company.name}
          companyLogoUrl={role.company.logoUrl || undefined}
          candidatePortalEnabled={role.candidatePortalEnabled}
        />
      ))}
    </div>
  );
};

export default RoleCardsList;
